import { render, staticRenderFns } from "./PartnerBase.vue?vue&type=template&id=19de6fa0&scoped=true&"
import script from "./PartnerBase.vue?vue&type=script&lang=js&"
export * from "./PartnerBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19de6fa0",
  null
  
)

export default component.exports